import { inject } from 'mobx-react';
import { ProfileMenuComponent } from './component';
export const ProfileMenu = inject(({ auth, ui, tenantSwitch }) => ({
    user: auth.userData,
    logout: auth.logout,
    setLanguage: ui.setLanguage,
    showLanguageMenu: ui.showLanguageMenu,
    currentTenantOption: tenantSwitch.currentOption,
    currentTenantShortName: tenantSwitch.currentTenantShortName,
}))(ProfileMenuComponent);
//# sourceMappingURL=index.js.map